// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file blacklist_service.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { BlacklistCreateSchema, BlacklistListRequestSchema, BlacklistListSchema, BlacklistSchema } from "./blacklist_pb";
import { file_blacklist } from "./blacklist_pb";
import type { EmptyMessageResponseSchema, IdRequestSchema } from "./general_pb";
import { file_general } from "./general_pb";

/**
 * Describes the file blacklist_service.proto.
 */
export const file_blacklist_service: GenFile = /*@__PURE__*/
  fileDesc("ChdibGFja2xpc3Rfc2VydmljZS5wcm90bxIJcmFjY29vbmFpMvQBChBCbGFja2xpc3RTZXJ2aWNlEkUKD0NyZWF0ZUJsYWNrbGlzdBIaLnJhY2Nvb25haS5CbGFja2xpc3RDcmVhdGUaFC5yYWNjb29uYWkuQmxhY2tsaXN0IgASTQoOTGlzdEJsYWNrbGlzdHMSHy5yYWNjb29uYWkuQmxhY2tsaXN0TGlzdFJlcXVlc3QaGC5yYWNjb29uYWkuQmxhY2tsaXN0TGlzdCIAEkoKD0RlbGV0ZUJsYWNrbGlzdBIULnJhY2Nvb25haS5JZFJlcXVlc3QaHy5yYWNjb29uYWkuRW1wdHlNZXNzYWdlUmVzcG9uc2UiAEIGWgQuL3Bi", [file_blacklist, file_general]);

/**
 * @generated from service raccoonai.BlacklistService
 */
export const BlacklistService: GenService<{
  /**
   * @generated from rpc raccoonai.BlacklistService.CreateBlacklist
   */
  createBlacklist: {
    methodKind: "unary";
    input: typeof BlacklistCreateSchema;
    output: typeof BlacklistSchema;
  },
  /**
   * @generated from rpc raccoonai.BlacklistService.ListBlacklists
   */
  listBlacklists: {
    methodKind: "unary";
    input: typeof BlacklistListRequestSchema;
    output: typeof BlacklistListSchema;
  },
  /**
   * @generated from rpc raccoonai.BlacklistService.DeleteBlacklist
   */
  deleteBlacklist: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof EmptyMessageResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_blacklist_service, 0);

